import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import delDialog from '@/components/System/DelDialog';
import FileUpload from '@/components/FileUpload/FileUpload';
import { saveFile, valsubstr32addbr } from '@/utils/index';
import manage from '@/constants/manage';
import windowHeightMixin from '@/mixins/windowHeightMixin';
export default {
  components: {
    delDialog: delDialog,
    FileUpload: FileUpload
  },
  mixins: [windowHeightMixin],
  props: {
    basicInfoFormData: {
      required: true,
      type: Object
    },
    ifAddOrEdit: {
      required: true,
      type: Boolean
    }
  },
  data: function data() {
    return {
      downloadErrorDialogVisible: false,
      errorFile: {},
      singleUserForm: {
        userId: '',
        userName: '',
        mngLevel: '',
        position: '',
        org: '',
        corner: 'A',
        manageOrgList: [],
        bizLineList: []
      },
      singleUserRules: {
        userId: [{
          required: true,
          message: '请选择用户名称或编号',
          trigger: 'change'
        }]
      },
      dictList: JSON.parse(sessionStorage.getItem('dist_info')),
      dictInfo: '',
      userOptions: [],
      userOptionLoading: false,
      bizLineList: [],
      filterForm: {
        userId: [],
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      },
      customizedUsers: [],
      delChecked: false,
      isIndeterminate: false,
      addDialogShow: false,
      uploadDialogShow: false,
      pagination: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      fileList: [],
      isUpdateUser: false,
      multipleSelection: [],
      ifShowDelDialog: false,
      userFilterData: {
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      },
      topId: manage.HEAD_ORG_ID
    };
  },
  created: function created() {
    var _this = this;
    this.getBusLines();
    this.getCustomizedUsers(this.basicInfoFormData.roleId, 1, 10);
    // 动态人员列表编辑人员成功或者上传动态人员文件成功后，需要更新固定用户列表
    this.$EventBus.$on('updateCustomizedUsers', function (_ref) {
      var needUpdate = _ref.needUpdate;
      if (needUpdate) {
        _this.getCustomizedUsers(_this.basicInfoFormData.roleId, 1, 10);
      }
    });
  },
  methods: {
    initChange: function initChange() {
      for (var i = 0; i < this.$refs.initChange.$el.querySelector('el-select__tags-text').children.length + 1; i++) {
        this.$refs.initChange.$el.querySelector('el-select__tags-text').children[i].setAttribute('title', this.$refs.initChange.$el.querySelector('el-select__tags-text').children[i].innerText);
      }
    },
    /**
     * @description 获取条线列表数据
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/13
     */
    getBusLines: function getBusLines() {
      this.dictInfo = this.dictList.BUSINESS_LINE || null;
      var obj = this.dictInfo;
      if (this.dictInfo !== null) {
        // eslint-disable-next-line guard-for-in
        for (var i in obj) {
          this.bizLineList.push({
            key: i,
            value: obj[i]
          });
        }
      }
    },
    /**
     * @description 获取固定用户列表数据
     * @param {String} roleId
     * @param {number} pageNum
     * @param {number} pageSize
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/13
     */
    getCustomizedUsers: function getCustomizedUsers(roleId, pageNum, pageSize) {
      var _this2 = this;
      this.$API.postRequest({
        url: '/platform/customizedUser/list',
        data: {
          bizLineList: this.filterForm.bizLineList || [],
          manageOrgList: this.filterForm.manageOrgMap || [],
          orgIdList: this.filterForm.orgMap || [],
          pageNum: pageNum,
          pageSize: pageSize,
          roleId: roleId,
          userIdList: this.filterForm.userId || [],
          systemId: this.basicInfoFormData.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.customizedUsers = Array.isArray(res.result.records) && res.result.records;
          _this2.customizedUsers.forEach(function (item) {
            item.mngLevel = _this2.dictList.MANAGER_LEVEL[item.mngLevel];
          });
          _this2.pagination.total = res.result.total;
        }
      });
    },
    /**
     * @description 获取筛选条件数据
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/13
     */
    getUserFilterData: function getUserFilterData() {
      var _this3 = this;
      var _this$basicInfoFormDa = this.basicInfoFormData,
        roleId = _this$basicInfoFormDa.roleId,
        systemId = _this$basicInfoFormDa.systemId;
      this.$API.getRequest({
        url: '/platform/customizedUser/conditions',
        data: {
          roleId: roleId,
          systemId: systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          var _res$result = res.result,
            bizLineList = _res$result.bizLineList,
            manageOrgMap = _res$result.manageOrgMap,
            orgMap = _res$result.orgMap;
          _this3.userFilterData.bizLineList = _this3.bizLineList.filter(function (item) {
            return bizLineList.includes(item.key);
          });
          _this3.userFilterData.manageOrgMap = manageOrgMap;
          _this3.userFilterData.orgMap = orgMap;
        }
      });
    },
    /**
     * @description 用户数据联想请求
     * @param {String} val 输入值
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/14
     */
    userRemoteMethod: function userRemoteMethod(val) {
      var _this4 = this;
      if (val === '') {
        return;
      }
      this.userOptionLoading = true;
      this.$API.getRequest({
        url: "/platform/component/userNameOrId/".concat(val),
        data: {}
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this4.userOptions = res.result;
        }
        _this4.userOptionLoading = false;
      });
    },
    /**
     * @description 根据联想数据自动带出用户默认信息
     * @param {String} val 用户编号
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/14
     */
    setUserDefaultInfo: function setUserDefaultInfo(val) {
      this.singleUserForm.userId = val;
      var selectedUser = this.userOptions.find(function (user) {
        return user.userId === String(val);
      });
      this.singleUserForm.userName = selectedUser.userName;
      this.singleUserForm.mngLevel = this.dictList.MANAGER_LEVEL[selectedUser.mngLevel];
      this.singleUserForm.position = selectedUser.jobList.map(function (jobItem) {
        return jobItem.jobName;
      }).join(',');
      this.singleUserForm.org = selectedUser.orgName;
      this.singleUserForm.orgId = selectedUser.orgId;
    },
    /**
     * @description 根据联想数据自动带出用户默认信息
     * @param {String} val 用户编号
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/14
     */
    confirmAddSingleUser: function confirmAddSingleUser() {
      var _this5 = this;
      this.$refs.userForm.validate(function (valid) {
        if (valid) {
          var _this5$basicInfoFormD = _this5.basicInfoFormData,
            autoComputeArea = _this5$basicInfoFormD.autoComputeArea,
            canSetBizLine = _this5$basicInfoFormD.canSetBizLine,
            roleId = _this5$basicInfoFormD.roleId,
            canSetManageOrg = _this5$basicInfoFormD.canSetManageOrg,
            systemId = _this5$basicInfoFormD.systemId;
          var _this5$singleUserForm = _this5.singleUserForm,
            bizLineList = _this5$singleUserForm.bizLineList,
            manageOrgList = _this5$singleUserForm.manageOrgList;
          var _this5$singleUserForm2 = _this5.singleUserForm,
            orgId = _this5$singleUserForm2.orgId,
            corner = _this5$singleUserForm2.corner,
            userId = _this5$singleUserForm2.userId;
          if (canSetManageOrg === 1 && manageOrgList.length < 1) {
            _this5.$message.warning('请选择管辖部门！');
            return;
          }
          if (canSetBizLine === 1 && bizLineList.length < 1) {
            _this5.$message.warning('请选择管辖条线！');
            return;
          }
          if (canSetManageOrg === 0) {
            manageOrgList = [];
          }
          if (canSetBizLine === 0) {
            bizLineList = [];
          }
          var payload = {
            autoComputeArea: autoComputeArea,
            bizLineList: bizLineList,
            canSetBizLine: canSetBizLine,
            canSetManageOrg: canSetManageOrg,
            corner: corner,
            manageOrgList: manageOrgList,
            orgId: orgId,
            roleId: roleId,
            userId: userId,
            systemId: systemId
          };
          var requestMethod = _this5.isUpdateUser ? _this5.$API.putRequest : _this5.$API.postRequest;
          requestMethod({
            url: '/platform/customizedUser',
            data: payload
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this5.$message.success("".concat(_this5.isUpdateUser ? '编辑' : '新增', "\u7528\u6237\u6210\u529F\uFF01"));
              _this5.addDialogShow = false;
              _this5.getCustomizedUsers(_this5.basicInfoFormData.roleId, 1, 10);
            }
          });
        }
      });
    },
    /**
     * @description 删除单个用户
     * @param {String} scope 单行数据
     * @param {Boolean} flag 是否确定删除
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/14
     */
    confirmDelUser: function confirmDelUser(scope, flag) {
      var _this6 = this;
      if (flag) {
        var _this$basicInfoFormDa2 = this.basicInfoFormData,
          roleId = _this$basicInfoFormDa2.roleId,
          systemId = _this$basicInfoFormDa2.systemId;
        this.$API.delRequest({
          url: '/platform/customizedUser',
          data: {
            roleId: roleId,
            systemId: systemId,
            userIdList: [scope.row.userId]
          }
        }).then(function (res) {
          if (res.code === '0000000000') {
            _this6.$message.success('删除用户成功！');
            _this6.pagination.pageNum = 1;
            _this6.pagination.pageSize = 10;
            _this6.getCustomizedUsers(_this6.basicInfoFormData.roleId, 1, 10);
          }
        });
      }
    },
    /**
     * @description 删除多个用户
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/15
     */
    confirmDelMutilpleUser: function confirmDelMutilpleUser() {
      var _this7 = this;
      this.ifShowDelDialog = false;
      var userIdList = [];
      if (this.delChecked) {
        this.customizedUsers.forEach(function (ele) {
          userIdList.push(ele.userId);
        });
      } else {
        this.multipleSelection.forEach(function (ele) {
          userIdList.push(ele.userId);
        });
      }
      var _this$basicInfoFormDa3 = this.basicInfoFormData,
        roleId = _this$basicInfoFormDa3.roleId,
        systemId = _this$basicInfoFormDa3.systemId;
      this.$API.delRequest({
        url: '/platform/customizedUser',
        data: {
          roleId: roleId,
          systemId: systemId,
          userIdList: userIdList
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this7.$message({
            message: '删除用户成功',
            type: 'success'
          });
          _this7.pagination.pageNum = 1;
          _this7.pagination.pageSize = 10;
          _this7.getCustomizedUsers(_this7.basicInfoFormData.roleId, 1, 10);
        }
      });
    },
    /**
     * @description 编辑用户，数据回显
     * @param {Object} scope 单行数据
     * @return {void}
     * @author 🦉Owllai🦉 2022/06/15
     */
    editUser: function editUser(scope) {
      var user = scope.row;
      var userName = user.userName,
        mngLevel = user.mngLevel,
        jobNameList = user.jobNameList,
        pathName = user.pathName,
        corner = user.corner,
        manageOrgList = user.manageOrgList,
        bizLineList = user.bizLineList,
        orgId = user.orgId,
        userId = user.userId;
      this.singleUserForm = {
        userId: userId,
        userName: userName,
        mngLevel: mngLevel,
        position: jobNameList,
        org: pathName,
        corner: corner,
        manageOrgList: manageOrgList || [],
        bizLineList: bizLineList || [],
        orgId: orgId
      };
      this.isUpdateUser = true;
      this.addDialogShow = true;
    },
    // 下载模板
    downloadTpl: function downloadTpl() {
      this.$API.getRequest({
        url: '/platform/file/templateDownload',
        data: {
          filePath: 'lc/template/批量维护固定用户模板.xlsx'
        },
        responseType: 'blob'
      }).then(function (res) {
        saveFile(res.data, '批量维护固定用户模板.xlsx');
      });
    },
    // 筛选popover框 ‘确定’按钮点击事件
    filterConfirm: function filterConfirm() {
      this.getCustomizedUsers(this.basicInfoFormData.roleId, 1, 10);
      this.$refs['filter-popover'].doClose();
    },
    resetFilterConfirm: function resetFilterConfirm() {
      this.filterForm = {
        userId: [],
        orgMap: [],
        manageOrgMap: [],
        bizLineList: []
      };
    },
    // table 点击全选事件
    selectAllUser: function selectAllUser(checked) {
      var _this8 = this;
      if (checked) {
        this.customizedUsers.forEach(function (ele) {
          _this8.$refs.multipleTable.toggleRowSelection(ele, true);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
      this.isIndeterminate = false;
    },
    // table 点击单选事件
    handleSelectionChange: function handleSelectionChange(val) {
      var checkedCount = val.length;
      this.delChecked = checkedCount === this.customizedUsers.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.customizedUsers.length;
      this.multipleSelection = val;
    },
    // 删除按钮点击事件
    delSelect: function delSelect() {
      if (this.multipleSelection.length > 0) {
        this.ifShowDelDialog = true;
      } else {
        this.$message({
          message: '请选择要删除的用户',
          type: 'warning'
        });
      }
    },
    currentChange: function currentChange(value) {
      this.pagination.pageNum = value;
      this.getCustomizedUsers(this.basicInfoFormData.roleId, this.pagination.pageNum, this.pagination.pageSize);
    },
    sizeChange: function sizeChange(value) {
      this.pagination.total = 0;
      this.pagination.pageNum = 1;
      this.pagination.pageSize = value;
      this.getCustomizedUsers(this.basicInfoFormData.roleId, this.pagination.pageNum, this.pagination.pageSize);
    },
    handleAddSingleUser: function handleAddSingleUser() {
      this.addDialogShow = true;
      this.isUpdateUser = false;
      this.singleUserForm = {
        userId: null,
        userName: '',
        mngLevel: '',
        position: '',
        org: '',
        corner: 'A',
        manageOrgList: [],
        bizLineList: []
      };
    },
    handleUploadUser: function handleUploadUser() {
      this.uploadDialogShow = true;
    },
    uploadSuccess: function uploadSuccess(fileList) {
      this.fileList = fileList;
    },
    uploadError: function uploadError(response) {
      this.errorFile = response;
      this.downloadErrorDialogVisible = true;
    },
    downloadError: function downloadError() {
      var _this9 = this;
      this.$API.getRequest({
        url: '/platform/file/templateDownload',
        data: {
          filePath: this.errorFile.message
        },
        responseType: 'blob'
      }).then(function (res) {
        saveFile(res.data, _this9.errorFile.message);
      });
    },
    exportCustomizedUsers: function exportCustomizedUsers() {
      var _this10 = this;
      this.$API.postRequest({
        url: '/platform/customizedUser/list/export',
        data: {
          bizLineList: this.filterForm.bizLineList || [],
          manageOrgList: this.filterForm.manageOrgMap || [],
          orgIdList: this.filterForm.orgMap || [],
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          roleId: this.basicInfoFormData.roleId,
          userIdList: this.filterForm.userId || [],
          systemId: this.basicInfoFormData.systemId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          return res.result;
        }
      }).then(function (_ref2) {
        var filePath = _ref2.filePath,
          exportMessage = _ref2.exportMessage;
        if (!filePath) {
          if (exportMessage) {
            _this10.$message({
              message: exportMessage,
              type: 'success'
            });
          }
          return;
        }
        _this10.$API.getRequest({
          url: '/platform/file/templateDownload',
          data: {
            filePath: filePath
          },
          responseType: 'blob'
        }).then(function (res) {
          saveFile(res.data, '固定用户列表导出文件.xlsx');
        });
      });
    },
    userSelectChange: function userSelectChange() {},
    orgHandle: function orgHandle() {},
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    }
  }
};